export default __webpack_public_path__ + "static/media/P350_SOV.8fbec296.pdf";